module.exports = __webpack_public_path__ + "static/media/02b.119c2891.jpg";